module.exports = __webpack_public_path__ + "static/img/img29.d3cd0cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img29.png
// module id = Qa/T
// module chunks = 1